/* eslint-disable @typescript-eslint/ban-ts-comment */

import { useState, useEffect } from 'react';

import { useLog, logType } from '@Utils/useLog';

export const useHttp = (url: string, options: RequestInit, dependencies: []) => {
	const [isLoading, setIsLoading]: [boolean, any] = useState(false);
	const [fetchedData, setFetchedData] = useState(null);
	const [errors, setErrors] = useState(null);

	useEffect(() => {
		setIsLoading(true);
		goFetch();
	}, dependencies);

	async function goFetch() {
		fetch(url, options)
			.then(response => {
				if (!response.ok) {
					throw new Error('Failed to fetch');
				}

				return response.json();
			})
			.then(data => {
				setIsLoading(false);
				setFetchedData(data);
			})
			.catch(err => {
				setErrors({ error: err + ':  ' + url });
				setIsLoading(false);
				useLog(logType.Info, err);
			});
	}

	return [isLoading, fetchedData, errors];
};

export const getHttp = async (url: string) => {
	let returnedData = null;

	const options = {
		method: 'GET',
		mode: 'cors',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		redirect: 'follow',
		referrerPolicy: 'no-referrer'
	};

	// @ts-ignore
	await fetch(url, options)
		.then(response => {
			if (!response.ok) {
				throw Error(response.statusText);
			}

			return response.json();
		})
		.then(data => {
			if (typeof data !== 'object') {
				returnedData = data;
			} else {
				returnedData = { status: true, ...data };
			}
		})
		.catch(err => {
			useLog(logType.Info, err);
			returnedData = { status: false, error: `error: ${err}` };
		});

	return returnedData;
};

export const postHttp = async (url: string, body: any) => {
	let returnedData = null;

	const options = {
		method: 'POST',
		mode: 'cors',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		redirect: 'follow',
		referrerPolicy: 'no-referrer',
		body: JSON.stringify(body)
	};

	// @ts-ignore
	await fetch(url, options)
		.then(response => {
			if (!response.ok) {
				throw Error(response.statusText);
			}

			return response.json();
		})
		.then(data => {
			if (!data) {
				returnedData = { status: true };
			}

			returnedData = { status: true, ...data };
		})
		.catch(err => {
			useLog(logType.Info, err);
			returnedData = { status: false, error: `error: ${err}` };
		});

	return returnedData;
};